<footer class="bg-gray-100 px-6 flex items-center justify-between text-xs text-gray-500 z-10 shrink-0">
  <div class="py-2">
    &copy; {{ currentYear }} Indian Railways. All rights reserved.
  </div>
  <div class="flex items-center gap-4 py-2">
    <span>Powered by <a href="https://vassarlabs.com/" target="_blank"
        class="font-medium text-brand-500 hover:text-brand-600 hover:underline">VassarLabs</a></span>
  </div>
</footer>